import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Box,
  CircularProgress,
  Container,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from 'src/Api';
import Page from 'src/components/Page';
import { Link as RouterLink } from 'react-router-dom';
import Iconify from 'src/components/Iconify';

export default function Home() {
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  const [loading, setloading] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  useEffect(() => {
    HandleGetService();
  }, []);

  const HandleGetService = () => {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      headers: myHeaders,
      method: 'POST',
      redirect: 'follow'
    };

    fetch(api.get_services, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        // console.log('body of home screen ', body);
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setServiceData(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
        } else {
          setloading(false);
          console.log('error.message', result.message);
        }
      })
      .catch((error) => {
        console.log('🚀 ~ HandleGetService ~ error:', error);
        setloading(false);
      });
  };

  const handlePageChange = (event, value) => {
    serviceData.length = 0;
    setPage(value);
    HandleGetService(value);
  };
  const userData = JSON.parse(localStorage.getItem('user'));

  return (
    <Page title={`Services | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Box mt={2}>
          {/* <Typography
            variant="h4"
            style={{ color: '#f90000', fontWeight: 'bold', marginBottom: 1 }}
          >
            Good Morning {userData?.name}{' '}
          </Typography> */}

          <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 5 }}>
            Welcome
          </Typography>
        </Box>

        <Paper
          elevation={3}
          sx={{
            flex: 1,
            height: 120,
            backgroundColor: '#f90000',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: '#fff',
              textAlign: 'center',
              flex: 1,
              justifyContent: 'center'
            }}
          >
            MonProgress will help you to see all of your ongoing progresses
          </Typography>
        </Paper>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0} mt={2}>
          <Typography variant="h4" sx={{ color: '#f90001' }}>
            Services
          </Typography>
        </Stack>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2, minWidth: 800 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#f00001', width: 300 }}>
                  Service Name
                </TableCell>
                {/* <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Created Date</TableCell> */}
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Sub Services</TableCell>
                {/* <TableCell sx={{ fontSize: '12px', color: '#f00001', width: 150 }}>
                  Status
                </TableCell> */}
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Action</TableCell>
              </TableRow>
            </TableHead>

            {!loading && (
              <TableBody>
                {serviceData.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell scope="row" padding="normal" style={{ width: 150 }}>
                      <Stack direction="row" alignItems="center" spacing={1} style={{ width: 150 }}>
                        {/* <Iconify alt={item.name} src={item?.image_url + '?v=' + Date.now()} /> */}
                        <Iconify
                          // icon={'mdi:truck-fast-outline'}
                          icon={item?.image_url_web}
                          sx={{ width: 30, height: 30, ml: 1, color: '#f90001' }}
                        />
                        <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                          <Typography variant="subtitle2" flexWrap={'wrap'}>
                            {item.name === 'undefined' ? 'N/A' : item.name}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>

                    {/* <TableCell>
                      <Typography style={{ fontSize: 12 }}>
                        {moment(item?.created_at).format('DD MMM YYYY') || '-'}
                      </Typography>
                    </TableCell> */}

                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>
                        {item?.sub_service_count || '-'}
                      </Typography>
                    </TableCell>

                    {/* <TableCell>
                      <Typography
                        className={
                          (item?.status.toLowerCase() == 'active' && 'status-green') ||
                          (item?.status.toLowerCase() == 'inactive' && 'status-blue')
                        }
                      >
                        {item?.status || 'N/A'}
                      </Typography>
                    </TableCell> */}

                    <TableCell>
                      <LoadingButton
                        variant="contained"
                        size="small"
                        style={{
                          color: '#ffff',
                          fontSize: 11,
                          baxShadow: 3
                        }}
                        component={RouterLink}
                        to="/dashboard/services/sub_services"
                        state={{ id: item?.id, service_name: item?.name }}
                      >
                        sub services
                      </LoadingButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={5} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {serviceData.length == 0 && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={5} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      height="55vh"
                    >
                      <Typography variant="h6" gutterBottom style={{ color: '#f90001' }}>
                        Service not found!
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && serviceData.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
